import React, { useEffect } from "react";
// import "./App.css";
import "./context/styles/themes.css"; // Adjust the path if necessary
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import ThemeProvider from "./context/ThemeContext";
import { AuthProvider } from "./context/AuthContext";
import { AnimatePresence } from 'framer-motion';
import { MediaDisplayProvider } from "./context/MediaDisplayModeContext";

// In sequence: Private page layout 
import HomePage from "./components/Pages/HomePage/HomePage";
import SelectLayout from './Layout/LayoutSelect';
import { useAuth } from "./context/AuthContext";
import EventPage from "./components/Pages/EventPage/EventPage";
import PostContentPage from "./components/Pages/PostContentPage/PostContentPage";
import LocationPage from "./components/Pages/LocationPage/LocationPage";


const PrivateRoute = ({ children }) => {
  const isLoggedIn = localStorage.getItem("status") === "loggedin";

  return isLoggedIn ? children : <Navigate to="/login" replace />;
};

// ✅ Redirect root path to the main Kleido domain
const RedirectToKleido = () => {
  window.location.replace(`https://kleido.ai/`);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route element={<SelectLayout />}>
          {/* <Route path="/" element={<Navigate to="/home" />} /> */}
          <Route path="/" element={<RedirectToKleido />} />
          <Route path="/event-page" element={<EventPage />}/>
          <Route path="/location-page/:suserId" element={<LocationPage />}/>          
          <Route path="/post-content/:userid/:groupid?" element={<PostContentPage />}/>

          {/* Public Routes */}
          <Route path="/home/:userid?" element={<HomePage />} />
        </Route>
      </Routes>
    </AnimatePresence>
  );
};


const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <MediaDisplayProvider>
          <Router>
            <AnimatedRoutes />
          </Router>
        </MediaDisplayProvider>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
